import { render } from "./RankingAndComparison.vue?vue&type=template&id=56d51d76&scoped=true"
import script from "./RankingAndComparison.vue?vue&type=script&lang=js"
export * from "./RankingAndComparison.vue?vue&type=script&lang=js"

import "./RankingAndComparison.vue?vue&type=style&index=0&id=56d51d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d51d76"]])

export default __exports__